import { Box, Typography } from "@material-ui/core";
import React from "react";
import { RouterProps } from "react-router-dom";

import { ActionButton } from "halifax";
import { PATH_AVAILABILITY, PATH_HOME } from "../../../../utils/paths";
import { transformToStringifiedAvailabilityQuery } from "../../../shop/utils/queryStringHelpers";
import { TitleSummaryCardConnectorProps } from "./container";
import "./styles.scss";
import { BACK_TO_RESULTS, SUBTITLE, TITLE } from "./textConstants";
import clsx from "clsx";
import queryStringParser from "query-string";

export interface ITitleSummaryCardProps
  extends TitleSummaryCardConnectorProps,
    RouterProps {
  isMobile?: boolean;
  isXmodRedesign?: boolean;
}

export const TitleSummaryCard = (props: ITitleSummaryCardProps) => {
  const {
    history,
    lodging,
    fromDate,
    untilDate,
    isMobile,
    adultsCount,
    childrenAges,
    roomsCount,
    isXmodRedesign,
  } = props;

  const returnToAvailability = () => {
    if (!lodging) {
      return history.push(PATH_HOME);
    }
    const queryString = queryStringParser.parse(history.location.search);
    const isTravelApp = queryString.isTravelApp === "true";

    // TODO: This needs to include state to be accurate, we don't have it.
    const search = transformToStringifiedAvailabilityQuery(
      lodging.lodging.city,
      fromDate,
      untilDate,
      adultsCount,
      childrenAges,
      roomsCount,
      undefined,
      undefined,
      isTravelApp,
    );
    history.push(`${PATH_AVAILABILITY}${search}`);
  };

  return (
    <Box className={clsx("title-summary-container", { xmod: isXmodRedesign })}>
      {!isMobile && (
        <ActionButton
          className="back-to-results"
          message={BACK_TO_RESULTS}
          onClick={() => {
            returnToAvailability();
          }}
          defaultStyle="h4r-secondary"
        />
      )}
      <Typography variant="h2" className="title">
        {TITLE}
      </Typography>
      <Typography variant="body1" className="subtitle">
        {SUBTITLE}
      </Typography>
    </Box>
  );
};
